import { useState, useEffect } from 'react';
import { useWallet } from './useWallet';

interface Member {
  address: string;
  amountLocked: string;
  amountUnlocking: string;
}

interface MembersResponse {
  members: Member[];
}

export function usePremiumStatus() {
  const { address, isConnected } = useWallet();
  const [isPremium, setIsPremium] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const checkPremiumStatus = async () => {
      if (!isConnected || !address) {
        setIsPremium(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);

        const response = await fetch('https://creator.bid/api/agents/676ef7b23bdebce80077f770/members');
        const data: MembersResponse = await response.json();

        // Find the member with matching address
        const member = data.members.find(m => 
          m.address.toLowerCase() === address.toLowerCase()
        );

        // Check if they have 10000 or more tokens locked
        if (member) {
          const lockedAmount = parseFloat(member.amountLocked);
          setIsPremium(lockedAmount >= 10000);
        } else {
          setIsPremium(false);
        }
      } catch (err) {
        console.error('Error checking premium status:', err);
        setError('Failed to check premium status');
        setIsPremium(false);
      } finally {
        setLoading(false);
      }
    };

    checkPremiumStatus();
  }, [address, isConnected]);

  return { isPremium, loading, error };
}